export default {
  setItem: (key: string, value: string) => Promise.resolve(localStorage.setItem(key, value)),
  getItem: (key: string) => Promise.resolve(localStorage.getItem(key)),
}
